/** @jsx tsx */
import { tsx } from "@dojo/framework/core/vdom";
import { DNode } from "@dojo/framework/core/interfaces";
import * as _ from "lodash";
import { PERCENTAGE_HUNDRED } from "../../Constants";
import { ImageCropShapeContainer } from "../containers/ShapeContainer";
import { IPicture } from "../interfaces/model/PageObjects/Picture";
import { IPageObjectRenderProps, PageObject } from "./PageObject";

/**
 * Picture renderer properties
 */
export interface IPictureRenderProps extends IPageObjectRenderProps<IPicture> {
    // link: string;
    // selectObject(selectedObject: number): void;
}

/**
 * Picture stateless renderer
 */
export class Picture extends PageObject<IPictureRenderProps> {
	/**
     * Render Picture text
     * Picture do not have text with it. Essentially this method should be noop.
     * For now, returning blank g tab
     */
	protected renderIfShapeTextBody(): DNode {
		return null;
	}

	protected getPreserveAspectRatio(): string {
		return "xMidYMid meet";
	}

	/**
     * @see PageObject.getViewBox()
     * We want to scale view box as per aspect ratio of image, so does not appear to be stretched.
     * FIXME (Rahul) Commenting this out for now. Image aspect ration should be maintained in all resize is the
     * overall requirement and this method tries to do the same. As part of image crop functionality, this alteration
     * is causing rendering issue for cropping shape. Hence, commenting it.
     */
	// protected getViewBox(): {height: number, left: number, top: number, width: number} {
	//     let viewBox = super.getViewBox();
	//     let {ext} = this.properties.pageObject.spPr.xfrm;
	//     // check if we want to scale width / height
	//     if (ext.cx > ext.cy) {
	//         viewBox.height = viewBox.height * ext.cy / ext.cx;
	//     } else {
	//         viewBox.width = viewBox.width * ext.cx / ext.cy;
	//     }
	//     return viewBox;
	// }

	/**
     * Render Picture.
     */
	protected renderObject(): DNode {
		const {
			depth,
			key,
			pageObject,
		} = this.properties;
		const { blip, srcShape: clipSource } = pageObject.blipFill;
		if (clipSource) {
			clipSource.spPr.xfrm = _.cloneDeep(pageObject.spPr.xfrm);
			clipSource.spPr.xfrm.off.x = 0;  // clip source x offset
			clipSource.spPr.xfrm.off.y = 0; // clip source y offset
		}
		return (
			<g>
				{clipSource && (
					<ImageCropShapeContainer
						depth={depth}
						key={key}
						pageObject={clipSource}
					/>
				)}
				<image
					clip-path={`url(#shape-${depth}-${key}-mask)`}
					height={`${PERCENTAGE_HUNDRED}%`}
					href={`${blip.link}`}
					ondblclick={this._onShapeDblClick}
					onpointerdown={this._onShapePointerDown}
					styles={{ pointerEvents: "visible" }}
					width={`${PERCENTAGE_HUNDRED}%`}
					x="0"
					y="0"
				/>
			</g>

		);
	}
}

export default Picture;
